import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import 'material-design-icons-iconfont/dist/material-design-icons.css' //
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    // options: {
    //   customProperties: true,
    // },
    themes: {
      light: {
        primary: '#2B5AC4', // indigo
        textprimary: '#2B5AC4',
        secondary: '#424242', // gris oscuro
        footerback: '#DDDDDD'
      },
      dark: {
        primary: '#161E33',
        colortextinfo: '#FFFFFF',
        backlogin: '#040b1d',
        btncolor: '#FFFFFF',
        textprimary: '#2B5AC4'
      }
    }
  },
  icons: {
    iconfont: 'mdi',
    iconfont: 'md',
    iconfont: 'fa'
  }
})
